import React, { Component } from 'react';
import { ButtonStyle, ButtonWrapper, LoadWrapper, Separator } from './DownloadLoadElement';
import { getTranslatedKey } from '../../../../../Utils/TranslateUtils';
import LocalMaps from './LocalMaps/LocalMaps';
import DefaultMaps from './DBMaps/DefaultMaps';
import UserMaps from './DBMaps/UserMaps';
import { displayComponents } from '../../../../../Utils/VisorsUtils';

export default class DownloadLoad extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 0,
      showTabs: true
    };
  }

  componentDidMount = () => {
    if (!this.props.user?.user || !this.props.intranet) {
      this.setState({ tab: 2, showTabs: false });
    }
    if (this.props.user.user && this.props.intranet) {
      if (!displayComponents.meusMapes && !displayComponents.mapesPredefinits) {
        this.setState({ tab: 2, showTabs: false });
      }
    }
    if (this.props.intranet && this.props.user?.aprov) {
      if (displayComponents.mapesPredefinits) {
        this.setState({ tab: 1 });
      } else {
        this.setState({ tab: 2 });
      }
    }
  };

  changeTab = (tab) => {
    this.setState({ tab: tab });
  };

  render() {
    return (
      <LoadWrapper>
        {this.state.showTabs && (
          <>
            <ButtonWrapper>
              {displayComponents.meusMapes && this.props.user?.user && !this.props.user?.aprov && (
                <ButtonStyle selected={this.state.tab === 0} onClick={() => this.changeTab(0)}>
                  {getTranslatedKey('myMaps')}
                </ButtonStyle>
              )}
              {displayComponents.mapesPredefinits && (
                <ButtonStyle selected={this.state.tab === 1} onClick={() => this.changeTab(1)}>
                  {getTranslatedKey('defaultMaps')}
                </ButtonStyle>
              )}
              {displayComponents.fitxerLocal && (
                <ButtonStyle selected={this.state.tab === 2} onClick={() => this.changeTab(2)}>
                  {getTranslatedKey('local')}
                </ButtonStyle>
              )}
            </ButtonWrapper>
            <Separator />
          </>
        )}
        {this.state.tab === 0 && (
          <UserMaps
            favList={this.props.favList}
            vectorTilesSource={this.props.vectorTilesSource}
            transparenciaFons={this.props.transparenciaFons}
            fontSizeEnabled={this.props.fontSizeEnabled}
            map={this.props.map}
            arrayLayers={this.props.arrayLayers}
            fonsActiu={this.props.fonsActiu}
            toggleAlert={this.props.toggleAlert}
            loadMap={this.props.loadMap}
            mapName={this.props.mapName}
          />
        )}
        {this.state.tab === 1 && <DefaultMaps loadMap={this.props.loadMap} />}
        {this.state.tab === 2 && (
          <LocalMaps
            favList={this.props.favList}
            vectorTilesSource={this.props.vectorTilesSource}
            transparenciaFons={this.props.transparenciaFons}
            fontSizeEnabled={this.props.fontSizeEnabled}
            map={this.props.map}
            arrayLayers={this.props.arrayLayers}
            fonsActiu={this.props.fonsActiu}
            loadMap={this.props.loadMap}
            mapName={this.props.mapName}
          />
        )}
      </LoadWrapper>
    );
  }
}
